var _ellipse, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrangeDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.08163,
    cy: 6.29551,
    rx: 6.14023,
    ry: 5.72763,
    fill: "url(#paint0_linear_23_958)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_958",
    x1: 10.0621,
    y1: 8.87697,
    x2: 3.0216,
    y2: -0.688943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0A13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7A30"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeDot);
export default __webpack_public_path__ + "static/media/OrangeDot.04322a4e849599dffd487d4b4d1a6487.svg";
export { ForwardRef as ReactComponent };